var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("viewer", { staticClass: "img-record" }, [
    _c("img", {
      staticStyle: {
        width: "auto",
        height: "auto",
        "max-width": "30%",
        "border-radius": "0%",
        "margin-top": "5px",
        "margin-right": "4px"
      },
      attrs: { src: _vm.src }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }